import { useMemo } from "react";
import { Theme } from "@mui/material/styles";
import { getTheme } from "../theme/theme";
import { useThemeMode } from "../contexts/ThemeModeContext";

/**
 * Возвращает MUI-тему, соответствующую текущему выбранному пользователем
 * режиму (см. `ThemeModeProvider`). Название сохранено для обратной
 * совместимости с существующими импортами.
 */
export const useTelegramTheme = (): Theme => {
  const { mode } = useThemeMode();
  return useMemo(() => getTheme(mode), [mode]);
};
